<template>
  <div>
      <tree-view id="treeview" :data="value" :options="{maxDepth: 1, modifiable: false}"></tree-view>
  </div>
</template>

<script>
export default {
  props: ["emitter", "ikey", "getData", "putData"],
  data() {
    return {
      value:{test:"test",out:"out"}
    };
  },
  methods: {
    update() {
      if (this.ikey) {
        this.putData(this.ikey, this.value);
      }
      this.emitter.trigger("process");
    }
  },
  mounted() {
    if (this.getData !== undefined) {
      this.value = this.getData(this.ikey);
     // console.log("key=" + this.ikey + " value=" + this.value);
    }
  }
};
</script>

<style>
#treeview {
  font-weight: normal;
  font-family: "Comic Sans MS", cursive, sans-serif;


}

#treeview .tree-view-item-key{
  font-size: xx-large
}
#treeview .tree-view-item-value {
  font-size: xx-large
}
#treeview .tree-view-item-hint {
  font-size: x-large
}


</style>
